
import Vue from "vue";
import Loader from "@/components/Multiloader.vue";
import RangeDiagramTableSwitch from "@/components/RangeDiagramTableSwitch.vue";

export default Vue.extend({
  name: "Quellschuettungen",
  components: {
    Loader,
    RangeDiagramTableSwitch
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      stammDataView: {
        name: "messstellen_grundwasser_stammdaten",
        condition: "messstellennummer=number:" + this.$route.params.id
      },
      measurementsView: {
        name: "messstellen_grundwasser_messwertequantitativ_messwerte",
        condition: "messst_nr=number:" + this.id
      },
      quellen: false,
      diagramData: {} as any
    };
  },
  computed: {
    tableHeader: function() {
      return (this as any).quellen
        ? [
            {
              text: "Datum",
              key: "DATUM"
            },
            {
              text: "Quellschüttung (l/s)",
              key: "ABSTICH"
            }
          ]
        : [
            {
              text: "Datum",
              key: "DATUM"
            },
            {
              text: "Messpunkthöhe [NN+m]",
              key: "NN_HOEHE"
            },
            {
              text: "Wasserstand",
              key: "WASSERSTAND"
            },
            {
              text: "Hinweis",
              key: "ZUSATZ_BEZ"
            }
          ];
    }
  },
  methods: {
    yaxisformatter(yValue: number) {
      return parseFloat(yValue.toFixed(2)).toLocaleString();
    },
    loadedData(data: any[]) {
      // data order : [stammDataView, measurementsView ]
      const stammdaten = data[0][0];
      const measureData = data[1];

      // fire event with entity type to component App
      this.$parent?.$parent?.$parent?.$emit("type", stammdaten.MESSSTELLENART);

      this.quellen = stammdaten?.MESSSTELLENART === "Quellen";

      /* Messwert Structure: {
       DATUM: "02.11.1953",
       ANA_DATUM: 158625100058
       NN_HOEHE: 0,
       ABSTICH: 0.47,
       WASSERSTAND: 0.47,
       MESSST_NR: 2548250300,
       MESSSTELLENBEZEICHNUNG: "5540 Altenbamberg,",
       ZUSATZ_BEZ: " - "
       },
       */

      const list = measureData
        // map data to format
        .map(messwert => {
          let element = {
            // default data
            xValue: Date.parse(messwert.ANA_DATUM),
            yValue: messwert.WASSERSTAND
          };
          // specific data
          if (this.quellen) {
            element = Object.assign(element, {
              nNHoehe: messwert.NN_HOEHE,
              abstich: messwert.ABSTICH,
              zusatzBez: messwert.ZUSATZ_BEZ
            });
          }
          return Object.assign(messwert, element);
        });

      // create diagram object
      this.diagramData = {
        list,
        quellen: this.quellen,
        xUnit: "",
        yUnit: this.quellen ? "l/s" : "NN+m",
        legendText: this.quellen ? "Quellschüttung (l/s)" : "Wasserstand (NN+m)"
      };
    }
  }
});
